import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { STOPS_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_STOPS_LIST = '_LOAD_STOPS_LIST';
export const CREATE_STOPS = '_CREATE_STOPS';
export const LOAD_STOPS_BY_ID = '_LOAD_STOPS_BY_ID';
export const EDIT_STOPS_BY_ID = '_EDIT_STOPS_BY_ID';
export const DELETE_STOPS = '_DELETE_STOPS';

export const loadStopsList = createDeferredAction(STOPS_MODULE + LOAD_STOPS_LIST);
export const loadStopsListBegin = createDeferredAction(STOPS_MODULE + LOAD_STOPS_LIST + BEGIN);
export const loadStopsListSuccessful = createAction(STOPS_MODULE + LOAD_STOPS_LIST + SUCCESSFUL);
export const loadStopsListFailed = createAction(STOPS_MODULE + LOAD_STOPS_LIST + FAILED);

export const createStops = createDeferredAction(STOPS_MODULE + CREATE_STOPS);
export const createStopsSuccessful = createAction(STOPS_MODULE + CREATE_STOPS + SUCCESSFUL);
export const createStopsFailed = createAction(STOPS_MODULE + CREATE_STOPS + FAILED);

export const loadStopsById = createDeferredAction(STOPS_MODULE + LOAD_STOPS_BY_ID);
export const loadStopsByIdSuccessful = createAction(STOPS_MODULE + LOAD_STOPS_BY_ID + SUCCESSFUL);
export const loadStopsByIdFailed = createAction(STOPS_MODULE + LOAD_STOPS_BY_ID + FAILED);
export const loadStopsByIdClear = createDeferredAction(STOPS_MODULE + LOAD_STOPS_BY_ID + CLEAR);

export const editStopsById = createDeferredAction(STOPS_MODULE + EDIT_STOPS_BY_ID);
export const editStopsByIdSuccessful = createAction(STOPS_MODULE + EDIT_STOPS_BY_ID + SUCCESSFUL);
export const editStopsByIdFailed = createAction(STOPS_MODULE + EDIT_STOPS_BY_ID + FAILED);

export const deleteStops = createDeferredAction(STOPS_MODULE + DELETE_STOPS);
export const deleteStopsSuccessful = createAction(STOPS_MODULE + DELETE_STOPS + SUCCESSFUL);
export const deleteStopsFailed = createAction(STOPS_MODULE + DELETE_STOPS + FAILED);
